import React from 'react';
import { version as ReactDOMVersion } from 'react-dom';
import ReactDOM from 'react-dom/client';
import _ from 'underscore';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { DateTime, Interval, Duration } from 'luxon';

import ToggleSwitch from 'src/react_components/toggle-switch';
import { NavigationTabs, NavigationTab } from 'src/react_components/navigation-tabs';
import SvgIcon from 'src/react_components/svg-icon';
import Snackbar, { SnackbarContext, withSnackbarProvider } from 'src/react_components/snackbar';
import AjaxUtilities from 'src/utilities/ajax-utilities';
import UseDataTable from 'src/utilities/use-data-table';
import { toOrdinal, humanizeDuration } from 'src/utilities/number-helpers';
import { generateLighterColorSequences } from 'src/utilities/color-helpers';

// Annotator
import AnnotatorCommentList, { YambaCommentList } from 'annotator/comment-list';
import FeedbackSummaryAreas from 'annotator/feedback-summary-areas';

// Burley
import BurleyQAHeader from 'src/react_components/burley-qa/header';
import BurleyQAFooter from 'src/react_components/burley-qa/footer';

import '../../../assets/javascripts/translations/translations.js.erb';

window._ = _;
window.React = React;
// @ts-ignore
window.ReactDOM = { ...ReactDOM, version: ReactDOMVersion };
window.ReactDOMClient = ReactDOM;
window.Redux = Redux;
window.ReactRedux = ReactRedux;

// Luxon
window.DateTime = DateTime;
window.Interval = Interval;
window.Duration = Duration;

window.ToggleSwitch = ToggleSwitch;
window.NavigationTabs = NavigationTabs;
window.NavigationTab = NavigationTab;
window.SvgIcon = SvgIcon;
window.Snackbar = Snackbar;
window.withSnackbarProvider = withSnackbarProvider;
window.SnackbarContext = SnackbarContext;
window.AjaxUtilities = AjaxUtilities;

// Annotator
window.CommentList = AnnotatorCommentList;
window.YambaCommentList = YambaCommentList;
window.FeedbackSummaryAreas = FeedbackSummaryAreas;

// Number helpers
Number.toOrdinal = toOrdinal;
window.humanizeDuration = humanizeDuration;

// Colour helpers
window.generateLighterColorSequences = generateLighterColorSequences;

// DataTable
window.UseDataTable = UseDataTable;

// Burley QA
window.BurleyQAHeader = BurleyQAHeader;
window.BurleyQAFooter = BurleyQAFooter;
